<template>

<div class="metric">

	<div class="metric-value">{{ value }}</div>
	<div class="metric-label">{{ label }}</div>

</div>

</template>

<script>

export default {

    props: ['label', 'value']

}

</script>

<style scoped>

.metric {
    background-color: rgba(255, 255, 255, 0.15);
}

.metric-value {
    padding: 15px 0px 14px 0px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
}

.metric-label {
    text-align: center;
    font-size: 14px;
    color: #fff;
    line-height: 16px;
    padding: 0px 5px 10px 5px;
}

</style>